<!-- format 1: Text Left | image Right  -->
<section *ngIf="boxList.boxPattern === textLeftImageRight" class="format-text-image {{ boxList.boxClassName }}">
  <div class="box-container bg-white">
    <!-- top heading -->
    <div *ngIf="boxList.boxTopHeading" class="top-heading">
      <div class="top-heading__subtitle"></div>
      <div class="top-heading__title"> </div>
      <div class="top-heading__detail"></div>
    </div>

    <div class="box">
      <div class="box__left">
        <div
          *ngIf="boxList.boxSubHeading"
          class="box__subheading"
          [innerHtml]="boxList.boxSubHeading | translate"
        ></div>

        <ng-container *ngIf="boxList.boxHeading">
          <div class="box__heading box__heading--desktop" [innerHtml]="boxList.boxHeading | translate"></div>
          <div class="box__heading box__heading--tablet" [innerHtml]="boxList.boxHeading_tablet | translate"></div>
          <div class="box__heading box__heading--mobile" [innerHtml]="boxList.boxHeading_tablet | translate"></div>
        </ng-container>

        <div
          *ngIf="boxList.boxHeadingDetail"
          class="box__heading-detail"
          [innerHtml]="boxList.boxHeadingDetail | translate"
        ></div>

        <div *ngIf="boxList.boxBtnLinkName" class="box__btn">
          <a
            href="{{ boxList.boxBtnLinkName | translate }}"
            rel="noopener noreferrer"
            target="_blank"
            class="flowbtn app-btn box__btn--href"
            [innerHtml]="boxList.boxBtnText | translate"
          >
          </a>
        </div>

        <div *ngIf="boxList.boxBtnRouteNameSubPath" class="box__btn">
          <a
            [routerLink]="[
              translate.currentLang === 'th' ? '' : '/en/',
              boxList.boxBtnRouteNamePath,
              boxList.boxBtnRouteNameSubPath
            ]"
            class="flowbtn app-btn box__btn--href"
            [innerHtml]="boxList.boxBtnText | translate"
          >
          </a>
        </div>
      </div>
      <div class="box__right">
        <picture>
          <source srcset="{{ boxList.boxImageWebP | translate }}" type="image/webp" />
          <source srcset="{{ boxList.boxImage | translate }}" type="image/{{ boxList.boxImageType | translate }}" />
          <img
            src="{{ boxList.boxImage | translate }}"
            width="100%"
            loading="lazy"
            alt="{{ boxList.boxImageAlt | translate }}"
            class="box__image"
          />
        </picture>
      </div>
    </div>
  </div>
</section>

<!-- format 2:  image left | text right-->
<section *ngIf="boxList.boxPattern === textRightImageLeft" class="format-image-text {{ boxList.boxClassName }}">
  <div class="box-container">
    <!-- top heading -->
    <div class="top-heading">
      <div class="top-heading__subtitle"></div>
      <div class="top-heading__title"> </div>
      <div class="top-heading__detail"></div>
    </div>

    <div class="box">
      <div class="box__left">
        <picture>
          <source srcset="{{ boxList.boxImageWebP | translate }}" type="image/webp" />
          <source srcset="{{ boxList.boxImage | translate }}" type="image/{{ boxList.boxImageType | translate }}" />
          <img
            src="{{ boxList.boxImage | translate }}"
            width="100%"
            loading="lazy"
            alt="{{ boxList.boxImageAlt | translate }}"
            class="box__image"
          />
        </picture>
      </div>
      <div class="box__right">
        <div
          *ngIf="boxList.boxSubHeading"
          class="box__subheading"
          [innerHtml]="boxList.boxSubHeading | translate"
        ></div>

        <ng-container *ngIf="boxList.boxHeading">
          <div class="box__heading box__heading--desktop" [innerHtml]="boxList.boxHeading | translate"></div>
          <div class="box__heading box__heading--tablet" [innerHtml]="boxList.boxHeading_tablet | translate"></div>
          <div class="box__heading box__heading--mobile" [innerHtml]="boxList.boxHeading_tablet | translate"></div>
        </ng-container>

        <div
          *ngIf="boxList.boxHeadingDetail"
          class="box__heading-detail"
          [innerHtml]="boxList.boxHeadingDetail | translate"
        ></div>

        <div *ngIf="boxList.boxBtnLinkName" class="box__btn">
          <a
            href="{{ boxList.boxBtnLinkName | translate }}"
            rel="noopener noreferrer"
            target="_blank"
            class="flowbtn app-btn box__btn--layout"
            [innerHtml]="boxList.boxBtnText | translate"
          >
          </a>
        </div>

        <div *ngIf="boxList.boxBtnRouteNameSubPath" class="box__btn">
          <a
            [routerLink]="[
              translate.currentLang === 'th' ? '' : '/en/',
              boxList.boxBtnRouteNamePath,
              boxList.boxBtnRouteNameSubPath
            ]"
            class="flowbtn app-btn box__btn--href"
            [innerHtml]="boxList.boxBtnText | translate"
          >
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
